// Module
var code = `<div class="btn-group schema-form-actions {{form.htmlClass}}">
  <input ng-repeat-start="item in form.items"
         type="submit"
         class="btn {{ item.style || 'btn-default' }} {{form.fieldHtmlClass}}"
         value="{{item.title}}"
         ng-if="item.type === 'submit'">
  <button ng-repeat-end
          class="btn {{ item.style || 'btn-default' }} {{form.fieldHtmlClass}}"
          type="button"
          ng-disabled="form.readonly"
          ng-if="item.type !== 'submit'"
          ng-click="buttonClick(\$event,item)"><span ng-if="item.icon" class="{{item.icon}}"></span>{{item.title}}</button>
</div>
`;
// Exports
module.exports = code;